import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateFormatService } from '@core/date/date-format.service';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';
import { InitialConfigService } from '../app-config/initial-config.service';
import { IAvailabilityGetData } from './availability-get-data.model';
import { ICalendarAvailability } from './calendar-availability.model';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityService {
  constructor(
    private http: HttpClient,
    private initialConfigService: InitialConfigService,
    private dateFormatService: DateFormatService,
    private appConfigService: AppConfigService
  ) {}

  /**
   * Gets availability data from the api to satisfy the following use cases.
   *  1) dateIndex: null, days: null, productId: null - should return venues current months availability
   *  2) dateIndex: 20220112, days: null, productId: null - should return availability data for the month of Jan
   *  3) dateIndex: null, days: 7, productId: null - should return data from venues current day for 7 days
   *  4) dateIndex: 20220112, days: 7, productId: null - should return data from 12 jan 2022 for 7 days
   *  5) dateIndex: null, days: null, productId: 21 - should return venues current months availability for productId 21
   *  6) dateIndex: 20220112, days: null, productId: 21 - should return month of Jan availability data for productId 21
   *  7) dateIndex: 20220112, days: 7, productId: 21 - should return data from 12 jan 2022 for 7 days for productId 21
   */
  getAvailabilityData(data: IAvailabilityGetData): Observable<ICalendarAvailability[]> {
    let params = data.date
      ? new HttpParams().set('dateIndex', this.dateFormatService.toDateIndex(data.date))
      : new HttpParams();
    if (data.isShort) {
      params = params.append('days', this.appConfigService.getAppValue<number>('dateArrayLength') || 7);
    }

    if (data.productId) {
      params = params.append('productId', data.productId);
    }

    const { baseApiUrl, checkoutSlug } = this.initialConfigService.getInitialConfig();
    return this.http.get<ICalendarAvailability[]>(`${baseApiUrl}/checkout/${checkoutSlug}/availability`, {
      params
    });
  }
}
